export const stripHtml = (value: string = '') =>
  value.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();

export const hasRichTextContent = (html?: string) => {
  const raw = html?.trim() || '';
  if (!raw) return false;
  return stripHtml(raw).length > 0 || /<img\s/i.test(raw);
};

type LegacyEducationItem = {
  degree?: string;
  institution?: string;
  year?: string;
};

/** Normalize legacy array education or HTML string for edit/display. */
export const memberEducationToHtml = (education: unknown): string => {
  if (typeof education === 'string') return education;
  if (!Array.isArray(education)) return '';
  return education
    .map((item: LegacyEducationItem) => {
      const degree = item?.degree?.trim() || '';
      const institution = item?.institution?.trim() || '';
      const year = item?.year?.trim() || '';
      const main = [degree, institution].filter(Boolean).join(' — ');
      if (!main && !year) return '';
      const text = year ? `${main}${main ? '，' : ''}${year}` : main;
      return `<p>${text}</p>`;
    })
    .filter(Boolean)
    .join('');
};
